import { ROLES } from "@iso/constants/common.constant";

export const SELECT_ROLES_ADMIN = [
  ROLES.ADMIN,
  ROLES.SUBADMIN,
  ROLES.CHAIN,
  ROLES.STORE,
  ROLES.USER,
];
export const SELECT_ROLES_CHAIN = [ROLES.CHAIN, ROLES.STORE];
export const SELECT_ROLES_STORE = [ROLES.STORE];

export const SELECT_STATUS = ["利用中", "停止"];

export const SELECT_DISABLE_CHAIN = [ROLES.ADMIN, ROLES.USER, ROLES.SUBADMIN, ""];
export const SELECT_DISABLE_STORE = [
  ROLES.ADMIN,
  ROLES.CHAIN,
  ROLES.USER,
  ROLES.SUBADMIN,
  "",
];
export const INPUT_DISABLE_EMAIL = [ROLES.CHAIN, ROLES.STORE];

export const SELECT_CONTRACT_STATUS = ["契約中", "解約", "停止"];

export const SELECT_TASK_PRIORITY_LIST = {
  OPTIONS: ["高", "中", "低"],
  DEFAULT: "中",
};

export const TASK_ESTIMATE_MODE = {
  AUTO: "AUTO",
  MANUAL: "MANUAL",
};

export const TASK_STATUS_MAPPING_COLOR = {
  未着手: "#F0C3C0",
  作業中: "#ACC6DF",
  担当者確認中: "#ABCFDB",
  施設確認中: "#B8D9D3",
  デザイン部依頼中: "#FCBA03",
  保留: "#A7A7A7",
  処理済: "#C6C8D9",
  施設チェック中: "#F5A6B4",
  完了: "#D7DCAC",
  依頼中: "#AA80FF",
  user: "transparent",
};

export const SELECT_TASK_STATUS_LIST = {
  OPTIONS: [
    "未着手",
    "作業中",
    "担当者確認中",
    "施設確認中",
    "デザイン部依頼中",
    "保留",
    "依頼中",
    "処理済",
    "施設チェック中",
    "完了",
  ],
  OPTIONS_CHAIN_STORE: [
    "完了",
  ],
  OPTIONS_GANTT_CHART: [
    "全て",
    "未着手",
    "作業中",
    "担当者確認中",
    "施設確認中",
    "デザイン部依頼中",
    "保留",
    "依頼中",
    "処理済",
    "施設チェック中",
    "完了",
  ],
  DEFAULT: "未着手",
  TASK_CHAIN_STORE_DEFAULT: "作業中",
  NOT_CLOSED: "完了以外",
  NOT_ON_HOLD: "保留以外",
  NOT_ASIGNEE_DROPDOWN: "全て",
  IN_PROGRESS_OPTIONS: [
    "未着手",
    "作業中",
    "担当者確認中",
    "施設確認中",
    "デザイン部依頼中",
    "保留",
    "依頼中",
    "処理済",
    "施設チェック中",
    "完了"
  ],
  KEY_COMPLETED: "COMPLETED",
};

// Task Status IDs (from task_statuses table)
export const TASK_STATUS_ID_NOT_STARTED = 1;  // 未着手
export const TASK_STATUS_ID_IN_PROGRESS = 2;  // 作業中
export const TASK_STATUS_ID_IN_REVIEW = 3;  // 担当者確認中
export const TASK_STATUS_ID_FACILITY_REVIEW = 4;  // 施設確認中
export const TASK_STATUS_ID_DESIGN_REQUEST = 5;  // デザイン部依頼中
export const TASK_STATUS_ID_ON_HOLD = 6;  // 保留
export const TASK_STATUS_ID_REQUESTED = 7;  // 依頼中
export const TASK_STATUS_ID_PROCESSED = 8;  // 処理済
export const TASK_STATUS_ID_FACILITY_CHECKING = 9;  // 施設チェック中
export const TASK_STATUS_ID_COMPLETED = 10;  // 完了

// Special filter status IDs (not in database)
export const TASK_STATUS_ID_NOT_CLOSED = -2;  // 完了以外
export const TASK_STATUS_ID_ALL = -1;  // 全て

export const TASK_STATUS_ID_MAPPING_COLOR = {
  [TASK_STATUS_ID_NOT_STARTED]: "#F0C3C0",  // 未着手
  [TASK_STATUS_ID_IN_PROGRESS]: "#ACC6DF",  // 作業中
  [TASK_STATUS_ID_IN_REVIEW]: "#ABCFDB",  // 担当者確認中
  [TASK_STATUS_ID_FACILITY_REVIEW]: "#B8D9D3",  // 施設確認中
  [TASK_STATUS_ID_DESIGN_REQUEST]: "#FCBA03",  // デザイン部依頼中
  [TASK_STATUS_ID_ON_HOLD]: "#A7A7A7",  // 保留
  [TASK_STATUS_ID_REQUESTED]: "#AA80FF",  // 依頼中
  [TASK_STATUS_ID_PROCESSED]: "#C6C8D9",  // 処理済
  [TASK_STATUS_ID_FACILITY_CHECKING]: "#F5A6B4",  // 施設チェック中
  [TASK_STATUS_ID_COMPLETED]: "#D7DCAC",  // 完了
  user: "transparent",
};

export const TASK_DETAIL_LOG_TABLE_TYPE = {
  SUMMARY: "summary",
  DETAIL: "detail",
};
export const TASK_DETAIL_COMMENT_TYPE = {
  USER: "USER",
  STORE: "STORE",
};

export const TASK_STOP_WATCH = {
  ACTIONS: {
    STOP: "STOP",
    START: "START",
  },
  TYPES: {
    EXECUTE: "EXECUTE",
    CONFIRM: "CONFIRM",
  },
};

export const SELECT_TEMPLATE = {
  UNIT: ["円", "%"],
  RECEIVE: ["受入不可", "受入可"],
  INCREASE_DECREASE: ["+", "-"],
};

export const SELECT_DISABLE_TEAM = [ROLES.CHAIN, ROLES.STORE, ""];

export const TASK_CONTENT_TYPES = {
  EXECUTE: "EXECUTE",
  CONFIRM: "CONFIRM",
};

export const CONTENT_STATUS = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
};

export const DAY_OF_WEEK = [
  { value: 'monday', name: '月' },
  { value: 'tuesday', name: '火' },
  { value: 'wednesday', name: '水' },
  { value: 'thursday', name: '木' },
  { value: 'friday', name: '金' }
];

export const SELECT_TYPE_AUTO_COPY_TASK = {
  DAY_OF_THE_WEEK: 1,
  DAY: 2,
  END_OF_THE_MONTH: 3,
  BEGINNING_OF_THE_MONTH: 4,
  END_OF_LAST_MONTH_AND_MIDDLE_OF_THIS_MONTH: 5,
  EVERY_DAY: 6
};

export const AUTO_COPY_EXECUTION_DAY_LAST = "last";

export const DP_SETTINGS = [
  { value: '有', label: 'page.taskAddEdit.extraField.presence'},
  { value: '無', label: 'page.taskAddEdit.extraField.absence'},
]

export const TEMPLATE_SALE_PLAN = [
  { value: '延長の場合', label: 'page.taskAddEdit.extraField.periodExtension'},
  { value: 'プラン新規作成の場合', label: 'page.taskAddEdit.extraField.createNewPlan'},
]

export const TASK_FORMAT_OPTIONS = [
  { value: '清書', label: 'page.tasks.taskFormat.origin'},
  { value: '下書き', label: 'page.tasks.taskFormat.draft'},
]

export const MODE_REPORT_OPTIONS = [
  { value: 1, label: 'page.crawlAdditionalRequest.onHand'},
  { value: 2, label: 'page.crawlAdditionalRequest.dor'},
  { value: 3, label: 'page.crawlAdditionalRequest.roomOccupancyRate'},
  { value: 4, label: 'page.crawlAdditionalRequest.leadTime'},
]

export const LIST_EXPORTED_CONTENTS_PLAN_COLUMN_CSV = [
  { id: 0, value: "taskId", name: "page.taskAddEdit.taskId" },
  { id: 1, value: "typeLabel", name: "page.exportedContents.type" },
  { id: 2, value: "teamName", name: "page.tasks.taskContent.team" },
  { id: 3, value: "contentDetail", name: "page.tasks.taskContent.content" },
  { id: 4, value: "contentId", name: "page.exportedContents.contentId" },
  { id: 5, value: "otaCount", name: "page.tasks.taskContent.otaCount" },
  { id: 6, value: "roomTypeCount", name: "page.tasks.taskContent.roomTypeCount" },
  { id: 7, value: "planCount", name: "page.tasks.taskContent.planCount" },
  { id: 8, value: "contentManual", name: "page.tasks.taskContent.manual" },
  { id: 9, value: "contentUnit", name: "page.tasks.taskContent.contentUnit" },
  { id: 10, value: "quantity", name: "page.tasks.taskContent.quantity" },
  { id: 11, value: "targetHours", name: "page.tasks.taskContent.estimateExecuteTime" },
  { id: 12, value: "previousQuantity", name: "page.tasks.taskContentPlan.previousQuantity" },
  { id: 13, value: "memo", name: "page.tasks.taskContent.memo" },
  { id: 14, value: "createdAtLabel", name: "page.tasks.taskContent.registrationDate" },
];

export const LIST_EXPORTED_CONTENTS_EXECUTION_COLUMN_CSV = [
  { id: 0, value: "taskId", name: "page.taskAddEdit.taskId" },
  { id: 1, value: "typeLabel", name: "page.exportedContents.type" },
  { id: 2, value: "teamName", name: "page.tasks.taskContent.team" },
  { id: 3, value: "memberName", name: "page.taskAchievement.member" },
  { id: 4, value: "contentDetail", name: "page.tasks.taskContent.content" },
  { id: 5, value: "contentId", name: "page.exportedContents.contentId" },
  { id: 6, value: "otaCount", name: "page.tasks.taskContent.otaCount" },
  { id: 7, value: "roomTypeCount", name: "page.tasks.taskContent.roomTypeCount" },
  { id: 8, value: "planCount", name: "page.tasks.taskContent.planCount" },
  { id: 9, value: "contentManual", name: "page.tasks.taskContent.manual" },
  { id: 10, value: "contentUnit", name: "page.tasks.taskContent.contentUnit" },
  { id: 11, value: "quantity", name: "page.tasks.taskContent.quantity" },
  { id: 12, value: "targetHours", name: "page.tasks.taskContent.estimateExecuteTime" },
  { id: 13, value: "actualHours", name: "page.tasks.taskContent.actualExecuteTime" },
  { id: 14, value: "memo", name: "page.tasks.taskContent.memo" },
  { id: 15, value: "createdAtLabel", name: "page.tasks.taskContent.registrationDate" },
];

export const LIST_CONTENT_COLUMN_CSV = [
  { id: 1, value: "contentDetail", name: "page.content.create.contentDetail" },
  { id: 2, value: "statusLabel", name: "page.contentList.status" },
  { id: 3, value: "teamName", name: "page.content.create.team" },
  { id: 4, value: "typeLabel", name: "page.content.create.type" },
  { id: 5, value: "estimateTime", name: "page.content.create.estimateTime" },
  { id: 6, value: "contentUnit", name: "page.content.create.contentUnit" },
  { id: 7, value: "contentManual", name: "page.contentList.link" },
];

export const LIST_TASK_COLUMN_CSV = [
  {id: 0, value: 'url', name: 'page.tasks.url' },
  {id: 1, value: 'storeName', name: 'page.tasks.store' },
  {id: 2, value: 'title', name: 'page.tasks.title'},
  {id: 3, value: 'categoryName', name: 'page.tasks.category'},
  {id: 4, value: 'assigneeName', name: 'page.tasks.assignee'},
  {id: 5, value: 'status', name: 'page.tasks.status'},
  {id: 6, value: 'memo', name: 'page.tasks.memo'},
  {id: 7, value: 'priority', name: 'page.tasks.priority'},
  {id: 8, value: 'registerDate', name: 'page.tasks.registerDate'},
  {id: 9, value: 'startDate', name: 'page.tasks.startDate'},
  {id: 10, value: 'dueDate', name: 'page.tasks.dueDate'},
  {id: 11, value: 'deliveryDate', name: 'page.tasks.actualDeliveryDate'},
  {id: 12, value: 'estTime', name: 'page.tasks.estimateTimeWork'},
  {id: 13, value: 'estPoint', name: 'page.tasks.estimateTimeCheck'},
  {id: 14, value: 'executeTime', name: 'page.tasks.executeTime'},
  {id: 15, value: 'confirmTime', name: 'page.tasks.confirmTime'},
  {id: 16, value: 'totalExecuteTime', name: 'page.tasks.totalWorkTime'},
  {id: 17, value: 'directorName', name: 'page.tasks.director'},
  {id: 18, value: 'registerPersonName', name: 'page.tasks.registerPerson'},
  {id: 19, value: 'executedTeamName', name: 'page.tasks.executedTeam'},
  {id: 20, value: 'fixedDeadline', name: 'page.tasks.fixedDeadline'},
];

export const INFANT_KODOMO_RURUBU = ['こどもA', 'こどもB', 'こどもC', 'こどもD'];

export const DATA_RANKING_SCORE_OTAS = [
  {id: 1, value: '楽天', name: '楽天'},
  {id: 2, value: 'じゃらん', name: 'じゃらん'},
  {id: 3, value: '一休', name: '一休'},
  {id: 4, value: 'るるぶ', name: 'るるぶ'},
  {id: 5, value: 'Trip.com', name: 'Trip.com'},
  {id: 6, value: 'Agoda', name: 'Agoda'},
  {id: 7, value: 'Booking', name: 'Booking'},
  {id: 8, value: 'Yahooトラベル', name: 'Yahooトラベル'},
];

export const DATA_COLLECTION_OTAS = [
  {id: 1, value: '楽天', name: '楽天'},
  {id: 2, value: 'じゃらん', name: 'じゃらん'},
];

export const DATA_BOOKING_POSITION_OTAS = [
  {id: 1, value: '楽天', name: '楽天'},
  {id: 2, value: 'じゃらん', name: 'じゃらん'},
  {id: 3, value: '一休', name: '一休'},
  {id: 4, value: 'るるぶ', name: 'るるぶ'},
  {id: 5, value: 'Trip.com', name: 'Trip.com'},
  {id: 6, value: 'Agoda', name: 'Agoda'},
  {id: 7, value: 'Booking', name: 'Booking'},
];

export const DATA_DOMESTIC_INDICATOR_OTAS = [
  {id: 1, value: '楽天', name: '楽天'},
  {id: 2, value: 'じゃらん', name: 'じゃらん'},
  {id: 3, value: '一休', name: '一休'},
];

export const TEAM_CONTENT_OPTIONS = [
  {id: 2, value: '利用中', name: '利用中'},
  {id: 3, value: '停止', name: '停止'},
];

export const TASK_WORK_CONFIRM_FIELD_PREFIX = {
  EXECUTE: "execute",
  CONFIRM: "confirm",
};

export const TASK_WORK_CONFIRM_CLASSIFICATION = [
  "新人研修",
  "対応不要",
  "指示変更",
  "依頼タスク",
  "依頼追加",
  "リソースオーバー",
  "ストップウォッチ",
  "ミス多発",
  "AD/PS/RS対応",
  "保留タスク",
  "他チームヘルプ",
];

export const TASK_WORK_CONFIRM_ADJUST_STATUS = [
  "調整済",
  "調整中",
  "調整不要",
];

/** Already stored on a task. Not rendered in the Select. Yup and the backend still accept these values. */
export const TASK_WORK_CONFIRM_ADJUST_STATUS_LEGACY = [
  "調整不可",
  "対応不要",
  "Regular調整済",
  "QM調整済",
];
